<div class="container">
  <svg
    class="info-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="200"
    viewBox="0 0 25 25"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="11"></line>
    <line x1="12" y1="8" x2="12" y2="8" />
  </svg>
  <h1>Mobile viewing is not supported at this resolution!</h1>
  <p>For the best experience, please access this portal on a higher-resolution device.</p>
</div>
